var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplianceCalendarEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#EEF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4122 10.2578H23.5916C15.095 10.2578 8.20703 17.1457 8.20703 25.6424V54.3604C8.20703 62.8571 15.095 69.745 23.5916 69.745H56.4122C64.9089 69.745 71.7968 62.8571 71.7968 54.3604V25.6424C71.7968 17.1457 64.9089 10.2578 56.4122 10.2578Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23H30C25.5817 23 22 26.5817 22 31V48C22 52.4183 25.5817 56 30 56H50C54.4183 56 58 52.4183 58 48V31C58 26.5817 54.4183 23 50 23Z",
    fill: "#4F7CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23H30C25.5817 23 22 25.9101 22 29.5C22 33.0899 25.5817 36 30 36H50C54.4183 36 58 33.0899 58 29.5C58 25.9101 54.4183 23 50 23Z",
    fill: "#7FA3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8191 18.976C32.8191 18.1263 32.1303 17.4375 31.2806 17.4375C30.431 17.4375 29.7422 18.1263 29.7422 18.976V24.1042C29.7422 24.9538 30.431 25.6426 31.2806 25.6426C32.1303 25.6426 32.8191 24.9538 32.8191 24.1042V18.976Z",
    fill: "#4F7CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2566 18.976C50.2566 18.1263 49.5678 17.4375 48.7181 17.4375C47.8685 17.4375 47.1797 18.1263 47.1797 18.976V24.1042C47.1797 24.9538 47.8685 25.6426 48.7181 25.6426C49.5678 25.6426 50.2566 24.9538 50.2566 24.1042V18.976Z",
    fill: "#4F7CFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9981 35.8984L48.2032 38.9754V44.1036C48.2032 49.2318 44.6135 52.8215 39.9981 54.36C35.3827 52.8215 31.793 49.2318 31.793 44.1036V38.9754L39.9981 35.8984Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4102 44.616L38.9743 47.1801L44.1025 41.5391",
    stroke: "#4F7CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5137 63.5899C65.0453 63.5899 68.7189 59.9164 68.7189 55.3848C68.7189 50.8532 65.0453 47.1797 60.5137 47.1797C55.9822 47.1797 52.3086 50.8532 52.3086 55.3848C52.3086 59.9164 55.9822 63.5899 60.5137 63.5899Z",
    fill: "#F4F6FB",
    stroke: "#D9DFEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5127 59.4864C62.7785 59.4864 64.6153 57.6496 64.6153 55.3838C64.6153 53.118 62.7785 51.2812 60.5127 51.2812C58.2469 51.2812 56.4102 53.118 56.4102 55.3838C56.4102 57.6496 58.2469 59.4864 60.5127 59.4864Z",
    stroke: "#6B7895"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53L63 58",
    stroke: "#6B7895",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceCalendarEmptyState);
export default __webpack_public_path__ + "static/media/compliance_calendar_empty_state.5261b3478fbf7a7f69d3905b0d900d56.svg";
export { ForwardRef as ReactComponent };